export default __webpack_public_path__ + "static/media/icon_checkbox_disabled.9b598611.svg";